import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Ruler, BookmarkPlus, X, Check } from "lucide-react";
import { toast } from "sonner";

let cache = null;
const load = async (force) => { if (!cache || force) cache = (await api.get("/recipe-measures")).data; return cache; };

export const MeasureInput = ({ value, onChange, index }) => {
  const [data, setData] = useState(cache || { saved: [], used: [] });
  const [open, setOpen] = useState(false);
  useEffect(() => { load().then(setData); }, []);

  const saveTemplates = async (items) => {
    try { const r = await api.put("/recipe-measures", { items }); cache = { ...data, saved: r.data.saved, used: data.used.filter((m) => !r.data.saved.includes(m)) }; setData(cache); }
    catch (e) { toast.error("Şablon kaydedilemedi"); }
  };
  const addCurrent = () => { const v = (value || "").trim(); if (!v) return toast.error("Önce ölçek notunu yazın"); if (data.saved.includes(v)) return; saveTemplates([...data.saved, v]); toast.success("Şablon kaydedildi"); };
  const pick = (m) => { onChange(m); setOpen(false); };
  const all = [...data.saved, ...data.used];

  return (
    <div className="flex items-center gap-1">
      <Input type="text" list={`measure-list-${index}`} value={value || ""} placeholder="Ölçek notu — örn. 4'lü beyaz ölçü kaşığının büyük tarafı ×2" maxLength={200}
        data-testid={`recipe-ing-measure-${index}`} className="h-7 flex-1 text-xs placeholder:text-muted-foreground/60" onChange={(e) => onChange(e.target.value)} />
      <datalist id={`measure-list-${index}`}>{all.map((m) => <option key={m} value={m} />)}</datalist>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" size="icon" variant="ghost" className="h-7 w-7 shrink-0" title="Ölçek şablonları" data-testid={`recipe-ing-measure-tpl-${index}`}><Ruler className="h-3.5 w-3.5" /></Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-80 p-2" data-testid="measure-templates">
          <div className="mb-1 flex items-center justify-between px-1">
            <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Ölçek Şablonları</span>
            <Button type="button" size="sm" variant="ghost" className="h-6 px-2 text-[11px]" onClick={addCurrent} data-testid="measure-save-current"><BookmarkPlus className="mr-1 h-3 w-3" /> Bu notu kaydet</Button>
          </div>
          <div className="max-h-56 space-y-0.5 overflow-y-auto">
            {data.saved.map((m) => (
              <div key={m} className="group flex items-center gap-1 rounded px-1.5 py-1 text-xs hover:bg-secondary">
                <button type="button" className="flex-1 truncate text-left" onClick={() => pick(m)} data-testid="measure-template-item">{value === m && <Check className="mr-1 inline h-3 w-3 text-primary" />}{m}</button>
                <button type="button" className="opacity-0 group-hover:opacity-100" title="Şablonu sil" onClick={() => saveTemplates(data.saved.filter((x) => x !== m))}><X className="h-3 w-3 text-destructive" /></button>
              </div>
            ))}
            {data.used.length > 0 && <p className="mt-1 px-1.5 text-[10px] uppercase tracking-wider text-muted-foreground">Reçetelerde kullanılanlar</p>}
            {data.used.map((m) => (
              <div key={m} className="group flex items-center gap-1 rounded px-1.5 py-1 text-xs hover:bg-secondary">
                <button type="button" className="flex-1 truncate text-left" onClick={() => pick(m)}>{m}</button>
                <button type="button" className="opacity-0 group-hover:opacity-100" title="Şablona ekle" onClick={() => saveTemplates([...data.saved, m])}><BookmarkPlus className="h-3 w-3 text-primary" /></button>
              </div>
            ))}
            {all.length === 0 && <p className="px-1.5 py-3 text-center text-xs text-muted-foreground">Henüz şablon yok — notu yazıp "Bu notu kaydet"e basın</p>}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
